<h2 mat-dialog-title>Advanced search</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput type="text" formControlName="search" />
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Area</mat-label>
        <mat-select formControlName="area">
          <mat-option value="Antarktis">Antarktis</mat-option>
          <mat-option value="Arktis">Arktis</mat-option>
          <mat-option value="Bouvetøya">Bouvetøya</mat-option>
          <mat-option value="Dronning Maud Land">Dronning Maud Land</mat-option>
          <mat-option value="Jan Mayen">Jan Mayen</mat-option>
          <mat-option value="Peter I Øy">Peter I Øy</mat-option>
          <mat-option value="Svalbard">Svalbard</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="draft">Draft</mat-option>
          <mat-option value="suggestion">Suggestion</mat-option>
          <mat-option value="official">Official</mat-option>
          <mat-option value="historical">Historical</mat-option>
          <mat-option value="standardised">Standardised</mat-option>
          <mat-option value="other">Other</mat-option>
        </mat-select>
      </mat-form-field>
    </p>

    <p>
      <mat-card class="npdc-leaflet" appearance="outlined">
        <app-leaflet-group
          [geometry]="geometry"
          [readonly]="false"
          [height]="'400px'"
          (geometryChange)="onGeometryChange($event)"
        >
        </app-leaflet-group>
      </mat-card>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="form.value" [disabled]="form.pristine || !form.valid">
    Search
  </button>
  <button mat-button type="button" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
